module.exports = __webpack_public_path__ + "img/type_curtain_city.61b56961.jpg";